import { LabelType, Options } from '@angular-slider/ngx-slider';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ProjectsFacade } from '@piqet-angular/data';
import { ICellEditorParams, ICellRendererParams } from 'ag-grid-community';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'piqet-angular-grid-new-add-project-slider',
  templateUrl: './grid-new-add-project-slider.component.html',
  styleUrls: ['./grid-new-add-project-slider.component.css'],
})
export class GridNewAddProjectSliderComponent {
  silderForm!: FormGroup;
  sliderValue = 0;
  params: any;
  public value!: number;
  options: Options = {
    floor: 0,
    ceil: 100,
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Low:
          return value + '%';
        case LabelType.High:
          return value + '%';
        default:
          return value + '%';
      }
    },
  };
  constructor(private formBuilder: FormBuilder, public projectFacade: ProjectsFacade) {}

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  agInit(params: ICellRendererParams<any, any>): void {
    this.params = params;
    this.sliderValue =
      this.params.data.recycledCreditId == 2
        ? 50
        : this.params.data.recycledCreditId == 1
        ? 20
        : params.data.range;
  }

  changeRuralValue(data: any) {
    this.params.data = cloneDeep(this.params.data);
    this.params.data.range = data.value;
    this.params.sliderData(this.params.data);
  }
}
